module.exports = __webpack_public_path__ + "static/media/SizeBadOptimized.32518de5.jp2";